import { createBrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import {
  RestorePasswordPage,
  NotFoundPage,
  LoginPage,
  SbpPaymentsPage,
  SbpPaymentView,
  ChangePasswordPage,
  B2BQrsPage,
  C2BQrsPage,
  OperationRequestsPage,
  TemplatePaymentsPage,
  TemplatePaymentView,
  B2CPage,
  B2CViewPage,
  B2CRegistryPage,
} from './pages'
import { DashboardLayout, RootLayout, AuthLayout } from './layouts'
import { AcquiringPaymentsPage } from './pages/acquiring-payments/acquiring-payments-page.tsx'
import { AcquiringPaymentView } from './pages/acquiring-payment-view'
import { APP_ROUTES } from './constants.ts'
import { RouteHandle } from './types.ts'

const removePathSlash = (path: string) => path.replace(/^./, '')
const createPathHandle = (params: RouteHandle<any>): RouteHandle<any> => params

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)

export const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <Sentry.ErrorBoundary />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: removePathSlash(APP_ROUTES.Login),
            element: <LoginPage />,
          },
          {
            path: removePathSlash(APP_ROUTES.Restore),
            element: <RestorePasswordPage />,
          },
          {
            path: removePathSlash(APP_ROUTES.ChangePassword),
            element: <ChangePasswordPage />,
          },
        ],
      },
      {
        element: <DashboardLayout />,
        children: [
          {
            path: removePathSlash(APP_ROUTES.SbpPayments),
            element: <SbpPaymentsPage />,
            handle: createPathHandle({
              pathTitle: 'Операции',
              // используется для кнопки назад в LayoutTitle
              goBack: false,
              permissionKey: 'showSbp',
            }),
            children: [
              {
                path: 'view/:id',
                element: <SbpPaymentView />,
                handle: createPathHandle({
                  goBack: true,
                  title: (params: { id: string }) => `Заказ № ${params.id}`,
                }),
              },
            ],
          },
          {
            path: removePathSlash(APP_ROUTES.B2BQrs),
            element: <B2BQrsPage />,
            handle: createPathHandle({
              pathTitle: 'Ссылки B2B QR',
              goBack: false,
              permissionKey: 'showQrB2b',
            }),
          },
          {
            path: removePathSlash(APP_ROUTES.C2BQrs),
            element: <C2BQrsPage />,
            handle: createPathHandle({
              pathTitle: 'Ссылки C2B QR',
              goBack: false,
              permissionKey: ['showQrC2b', 'showQrC2bStatic'],
            }),
          },
          {
            path: removePathSlash(APP_ROUTES.B2C),
            element: <B2CPage />,
            handle: createPathHandle({
              pathTitle: 'Переводы физ. лицам (В2С)',
              goBack: false,
              permissionKey: ['showB2c'],
            }),
            children: [
              {
                path: 'registry/:id',
                element: <B2CRegistryPage />,
                handle: createPathHandle({
                  goBack: true,
                  title: (params: { id: string }) => `Реестр переводов физ. лицам № ${params.id}`,
                }),
              },
              {
                path: 'view/:id',
                element: <B2CViewPage />,
                handle: createPathHandle({
                  goBack: true,
                  title: (params: { id: string }) => `Перевод физ. лицу № ${params.id}`,
                }),
              },
            ],
          },
          {
            path: removePathSlash(APP_ROUTES.AcqPayments),
            element: <AcquiringPaymentsPage />,
            handle: createPathHandle({
              pathTitle: 'Операции эквайринга',
              goBack: false,
              permissionKey: 'showAcqOperations',
            }),
            children: [
              {
                path: 'view/:id',
                element: <AcquiringPaymentView />,
                handle: createPathHandle({
                  goBack: true,
                  title: (params: { id: string }) => `Заказ № ${params.id}`,
                }),
              },
            ],
          },
          {
            path: removePathSlash(APP_ROUTES.OperationRequests),
            element: <OperationRequestsPage />,
            handle: createPathHandle({
              pathTitle: 'Разовые страницы оплаты',
              goBack: false,
              permissionKey: 'showOneTimePage',
            }),
          },
          {
            path: removePathSlash(APP_ROUTES.TemplatePayments),
            element: <TemplatePaymentsPage />,
            handle: createPathHandle({
              pathTitle: 'Статические страницы оплаты',
              goBack: false,
              permissionKey: 'showStaticTemplate',
            }),
            children: [
              {
                path: 'view/:id',
                element: <TemplatePaymentView />,
                handle: createPathHandle({
                  goBack: true,
                  title: (params: { id: string }) => `Статическая страница оплаты № ${params.id}`,
                }),
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
